import React, { useEffect, useState, useRef } from 'react';
import { getSingleWidgetDetail } from "../../../../staticWidgets/utils/CommonWidgetApi";
import { getDummyNumberCounter, getTemplateDetail } from "../../../../utils/numberCounterApi";

const WhiteThemeTemplateWidget = ({ isTemplateId, widgetId, numberCounterTabData,refreshWidgetList }) => {
    const [apiData, setApiData] = useState(null);
    const [counters, setCounters] = useState({});
    const animationRefs = useRef([]);
    const [animationTrigger, setAnimationTrigger] = useState(0);

    const {
        is_website_frontend,
        number_of_columns,
        space_between_counters,
        position_alignment,
        widget_title,
        background_color,
        widget_title_color,
        widget_title_size,
        counter_background_color,
        number_color,
        number_size,
        caption_color,
        caption_size,
        icon_background_color,
        is_enable_number_formatting,
        width,
        icon_font_size
    } = numberCounterTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/number-counter/temp-css/NumberCounter.css`;
        if (widgetId) {
            link.setAttribute("number-counter-data-dynamic-css", "number-counter");
        } else {
            link.setAttribute("data-dynamic-css", "number-counter");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="number-counter"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    // Fetch data
    useEffect(() => {
        const fetchData = async () => {
            try {
                let result;
                if (isTemplateId) {
                    result = await getTemplateDetail(isTemplateId);
                } else if (widgetId) {
                    result = await getSingleWidgetDetail(widgetId);
                } else {
                    result = await getDummyNumberCounter();
                }
                setApiData(result);
            } catch (error) {
                //console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [isTemplateId, widgetId, refreshWidgetList]);

    // Restart counter when is_enable_number_formatting changes
    useEffect(() => {
        if (apiData?.data?.data_list) {
            setAnimationTrigger(prev => prev + 1);
        }
    }, [is_enable_number_formatting,apiData]);    

    // Animate counters when apiData or animationTrigger changes
    useEffect(() => {
        if (!apiData || !apiData.data || !apiData.data.data_list) return;

        animationRefs.current.forEach(clearInterval);
        animationRefs.current = [];

        const newCounters = {};
        apiData.data.data_list.forEach((item, index) => {
            const start = Number(item.start_value) || 0;
            const end = Number(item.end_value) || 0;
            const duration = 2000;
            const stepTime = 30;
            const steps = Math.floor(duration / stepTime);
            const increment = (end - start) / steps;

            let current = start;
            let count = 0;

            const interval = setInterval(() => {
                count++;
                current += increment;

                const done = (increment >= 0 && current >= end) || (increment < 0 && current <= end);
                newCounters[index] = Math.round(done ? end : current);

                setCounters(prev => ({
                    ...prev,
                    ...newCounters
                }));

                if (done || count >= steps) {
                    clearInterval(interval);
                }
            }, stepTime);

            animationRefs.current.push(interval);
        });

        return () => {
            animationRefs.current.forEach(clearInterval);
            animationRefs.current = [];
        };
    }, [apiData, animationTrigger]);

    const getMarginInline = (alignment) => {
        switch (alignment) {
          case 'right':
            return 'auto 0';
          case 'left':
            return '0 auto';
          case 'center':
            return 'auto';
          default:
            return '0';
        }
    };

    return (
        <div className={`upgadeify number_counter white-theme-temp ${is_website_frontend}`}>
            <div className={`number_counter_widget`} style={{ backgroundColor: background_color }}>
                <h4 className='number_counter_widget_title' style={{ color: widget_title_color, fontSize: widget_title_size }}>{widget_title}</h4>
                <div className='number_counter_inner' style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${number_of_columns || 1}, 1fr)`,
                            gap: space_between_counters
                        }}>
                
                    {apiData ? (
                        apiData.data.data_list.map((item, index) => (
                            <div key={index} className='number_count' style={{ backgroundColor: counter_background_color,width: width+"px", textAlign: position_alignment}}>
                                {item.image && (
                                    <div className='number_count_icon' style={{
                                            backgroundColor: icon_background_color,
                                            fontSize: `calc(${icon_font_size} * 0.5)`,
                                            width: icon_font_size,
                                            height: icon_font_size,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginInline: getMarginInline(position_alignment),
                                        }}>
                                        <img src={item.image} alt={item.image_name} style={{
                                            width: `calc(${icon_font_size} * 0.6)`,
                                            height: `calc(${icon_font_size} * 0.6)`,
                                            objectFit: 'contain',
                                            }}/>
                                    </div>
                                )}
                                <div className='number_count_text'>
                                    <h3 style={{ color: number_color, fontSize: number_size }}>
                                        {item.prefix}
                                        {Number(is_enable_number_formatting) === 1
                                            ? (counters[index] ?? item.start_value).toLocaleString()
                                            : (counters[index] ?? item.start_value)
                                        }
                                        {item.postfix}
                                    </h3>
                                    <p style={{ color: caption_color, fontSize: caption_size }}>{item.caption}</p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="loader-container">
                            <div className="spinner"></div>
                            <p>Loading please wait...</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WhiteThemeTemplateWidget;
